import React from 'react';
import './ListBody.css';

const ListBody = ({
  headers,
  items,
  selectedItems,
  handleSelectAll,
  handleItemSelect, // 개별 선택 함수
  sort,
  desc,
  handleSortChange,
  setSort,
  setDesc,
  renderActions,
  onRowClick,
  className = ""
}) => {
  return (
    <div className={`table ${className}`}>
      <div className="thead">
        <div className="tr">
          <div className="th">
            <label></label>
            <span>
              <input
                type="checkbox"
                onChange={(e) => handleSelectAll(e.target.checked)}
                checked={
                  items && Array.isArray(items) && items.length > 0 &&
                  selectedItems.length === items.length
                }
              />
            </span>
          </div>
          {headers.map((header, index) => {
            return (
              <div 
                key={index} 
                className="th" 
                onClick={() => header.value && handleSortChange(header.value, sort, setSort, setDesc)}
                style={{ cursor: header.value ? 'pointer' : 'default' }}
              >
                {header.name} {header.value !== "" && sort === header.value ? (desc === 'desc' ? '▼' : '▲') : ''}
              </div>
            );
          })}
          {renderActions && <div className="th">액션</div>}
        </div>
      </div>
      <div className="tbody">
        {items && items.length > 0 ? (
          items.map((item, index) => {
            return (
              <div 
                key={index} 
                className="tr"
                onClick={() => onRowClick && onRowClick(item)}
                style={{ cursor: onRowClick ? 'pointer' : 'default' }}
              >
                <div className="td">
                  <label></label>
                  <span>
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item.id)}
                      onChange={(e) => {
                        e.stopPropagation(); // 행 클릭 이벤트 방지
                        handleItemSelect(item.id, e.target.checked);
                      }}
                    />
                  </span>
                </div>
                {headers.map((header, headerIndex) => (
                  <div key={headerIndex} className="td">
                    <label>{header.name}</label>
                    <span>
                      {/* header.renderCell이 있으면 사용, 없으면 기본값 */}
                      {header.renderCell ? header.renderCell(item) : item[header.value]}
                    </span>
                  </div>
                ))}
                {renderActions && (
                  <div className="td">
                    {renderActions(item, index)}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="tr">
            <div className="td" colSpan={headers.length + (renderActions ? 2 : 1)} style={{ textAlign: 'center' }}>
              데이터가 없습니다.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListBody;